import * as R from "ramda";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { actions, getters } from "../../../store";

const makeHeaderOptions = (value) => ({
  valueTransform: Object.assign(
    () => <h2 style={{ textTransform: "uppercase" }}>{value}</h2>,
    { displayName: value }
  ),
});

export const tableConfig = {
  cellOptions: { on: {} },
  headerOptions: { on: {} },
  rowOptions: { on: {} },
  data: [
    {
      order: 0,
      name: "orderId",
      cellOptions: { on: {} },
      headerOptions: makeHeaderOptions("Order Id"),
    },
    {
      order: 1,
      name: "subtotal",
      cellOptions: { on: {} },
      headerOptions: makeHeaderOptions("Document Charge"),
    },
    {
      order: 2,
      name: "convenienceFee",
      cellOptions: { on: {} },
      headerOptions: makeHeaderOptions("Convenience Fee"),
    },
    {
      order: 3,
      name: "certificationFee",
      cellOptions: { on: {} },
      headerOptions: makeHeaderOptions("Certification Fee"),
    },
    {
      order: 4,
      name: "totalCharged",
      cellOptions: { on: {} },
      headerOptions: makeHeaderOptions("Total Charged"),
    },
    {
      order: 5,
      name: "orderDate",
      cellOptions: { on: {} },
      headerOptions: makeHeaderOptions("Date"),
    },
    {
      order: 6,
      name: "userName",
      cellOptions: { on: {} },
      headerOptions: makeHeaderOptions("Name"),
    },
    {
      order: 7,
      name: "userEmail",
      cellOptions: { on: {} },
      headerOptions: makeHeaderOptions("Email"),
    },
    {
      order: 8,
      name: "numberOfItems",
      cellOptions: { on: {} },
      headerOptions: makeHeaderOptions("Number Of Documents"),
    },
  ],
};

const mapDispatchToProps = (dispatch) => ({
  fetchData: (searchData) => dispatch(actions.billingReport.fetch(searchData)),
  fetchTotals: (totalsData) =>
    dispatch(actions.billingReport.fetchTotals(totalsData)),
});

const mapStateToProps = (state) => ({
  data: getters.billingReport.tableView(state),
  totalsData: getters.billingReport.totals(state),
  pagination: getters.billingReport.pagination(state),
  csvUrl: getters.billingReport.csvUrl(state),
  isLoading: getters.billingReport.loading(state),
  county: getters.county(state),
});

export default R.compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
);
